import React from "react";
import _get from "lodash/get";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import { Formik, Form } from "formik";
// import { signIn } from "../../actions/auth/authActions";
import { getTimeZone } from "../../actions/momentActions";
import { createUser } from "../../actions/adminDashActions";
import { getResellers } from "../../actions/reseller/resellerActions";
import { validate } from "./validate";
import Grid from '@mui/material/Grid';
import InputBox from "../../components/InputBox";
import SelectBox from "../../components/SelectBox";
import Error from "../Error";
import Success from "../Success";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
import Typography from '@mui/material/Typography';
import CheckBox from "../../components/CheckBox";
import Alert from '@mui/material/Alert';
import {LABELS as _LABELS} from "../../language";

const LABELS=_LABELS.resellerForm;



const styles = (theme) => ({
  wrapper: {},
  DialogActions: {
    marginTop: 25,
    textAlign: "right",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

export class AddUserForm extends React.Component {
  state = {
    resellers: [],
  };

  // componentDidMount() {}

  async componentDidMount() {
    await this.getResellers();
  }

  getResellers = async () => {
    const resellers = await this.props.getResellers();
    this.setState({ resellers });
  };

  handleSubmit = async (values) => {
    if (values.resellerId) {
      values.role = "PARTNER";
    }

    let response = await this.props.createUser(values);
    if (response && response._id) {
      this.setState({
        successMessage: "User is updated successfully",
        loading: false,
      });
      setTimeout(() => {
        this.props.handleClose();
      }, 1000);
    } else if (response && response.message) {
      this.setState({ errorMessage: response.message, loading: false });
    } else {
      if (typeof response !== String) {
        response = "Something went wrong, please try after time.";
      }
      this.setState({ errorMessage: response, loading: false });
    }
  };

  render() {
    const { classes, } = this.props;
    const resellers = this.state.resellers;
    const { errorMessage, successMessage, loading } = this.state;
    const isSmallScreen = window.innerWidth < 500;
    return (
      <Dialog
        fullScreen={isSmallScreen}
        fullWidth={true}
        maxWidth={"md"}
        className={classes.wrapper}
        open={!!this.props.open}
        onClose={this.props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" onClose={this.props.handleClose}>
          <Typography>{LABELS.addSupportUser}</Typography>
          <IconButton
            aria-label="Close"
            className={classes.closeButton}
            onClick={this.props.handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Alert severity="warning">
            {
              // "Note:-  This is only for adding new support user. Support user will have access to all your account and carrier details."
              LABELS.note
            }
          </Alert>
          <Formik
            initialValues={{
              role: "ADMIN",
            }}
            validate={validate}
            onSubmit={this.handleSubmit}
            enableReinitialize={true}
          >
            {({ values, handleSubmit, setFieldValue, errors }) => {
              return (
                <Form style={{ padding: "20px 10px" }}>
                  <Grid container spacing={3}>
                    <InputBox md={4} name="firstName" label={LABELS.firstName}/>
                    <InputBox md={4} name="lastName" label={LABELS.lastName} />
                    <InputBox md={4} name="mobile" label={LABELS.mobile} />
                    <InputBox md={4} name="email" label={LABELS.email}/>
                    <InputBox md={4} name="password" label={LABELS.password} />
                    <CheckBox md={4} name="adminAccess" label={LABELS.superAdmin}/>
                    <SelectBox
                      md={4}
                      name="resellerId"
                      label={LABELS.reseller}          
                      selLabel={"name"}
                      selValue={"_id"}
                      items={resellers}
                      onChange={(e) => setFieldValue("adminAccess", false)}
                    />
                  </Grid>
                  {successMessage && <Success message={successMessage} />}
                  {errorMessage && <Error message={errorMessage} />}
                  <div className={classes.DialogActions}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={loading}
                    >
                      {/* {loading ? "Saving...": "SAVE"} */}
                      {`${loading ? LABELS.saving:LABELS.save}`}
                    </Button>{" "}
                    <Button
                      variant="contained"
                      onClick={this.props.handleClose}
                    >
                      {/* CLOSE */}
                      {LABELS.close}
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </DialogContent>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    constants: _get(state, "appData.constants", {}),
    errorMessage: _get(state, "equipmentData.error", ""),
    loading: _get(state, "accountData.accountCreateBusy", false),
    accountValues: _get(state, "form.accountForm.values", {}),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createUser,
      getTimeZone,
      getResellers,
    },
    dispatch
  );

export default withStyles(styles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(AddUserForm))
);
